// Antd v5 theme tokens for the physician-facing front-end.
//
// Ported from the legacy `src/theme.js` Less variable map. Component-specific
// overrides live under `components` and follow antd v5's token API. Anything
// that used to live in `packages/case-view/styles/antd-theme.css` should
// move into this map as we audit the upgrade.

const PRIMARY = '#7BAD7E';
const TEXT = '#7c7c7c';
const HEADING = '#7c7c7c';
const BORDER = '#E1E6ED';
const LAYOUT_BG = '#f4f4f4';
const COMPONENT_BG = '#FFFFFF';

export const antdTheme = {
  token: {
    colorPrimary: PRIMARY,
    colorLink: PRIMARY,
    colorLinkHover: '#6a9a6d',
    colorLinkActive: '#5a8a5d',
    colorSuccess: '#36b639',
    colorError: '#eb0404',
    colorBgLayout: LAYOUT_BG,
    colorBgContainer: COMPONENT_BG,
    colorText: TEXT,
    colorTextHeading: HEADING,
    colorBorder: BORDER,
    colorBorderSecondary: BORDER,
    colorSplit: COMPONENT_BG,
    borderRadius: 4,
    fontFamily:
      "'Montserrat', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Helvetica Neue', Helvetica, sans-serif",
  },
  components: {
    Layout: {
      bodyBg: LAYOUT_BG,
      headerBg: '#FFFFFF',
      siderBg: '#FFFFFF',
    },
    Table: {
      headerBg: LAYOUT_BG,
      headerColor: '#171C2F',
      rowHoverBg: LAYOUT_BG,
      cellPaddingBlock: 16,
      cellPaddingInline: 16,
    },
    Menu: {
      itemColor: TEXT,
      itemSelectedColor: PRIMARY,
      itemHoverBg: LAYOUT_BG,
      itemSelectedBg: LAYOUT_BG,
      itemActiveBg: LAYOUT_BG,
    },
    Tabs: {
      inkBarColor: PRIMARY,
      itemSelectedColor: PRIMARY,
      itemHoverColor: PRIMARY,
      itemActiveColor: PRIMARY,
    },
    Button: {
      colorPrimary: PRIMARY,
      primaryColor: '#fff',
      defaultBg: PRIMARY,
      defaultColor: '#fff',
      defaultBorderColor: '#C7CBCE',
    },
    Radio: {
      buttonCheckedBg: PRIMARY,
      buttonSolidCheckedColor: '#fff',
      colorPrimary: PRIMARY,
    },
    Input: {
      hoverBorderColor: PRIMARY,
      activeBorderColor: PRIMARY,
      colorTextPlaceholder: '#848C94',
    },
    Select: {
      colorBgContainer: COMPONENT_BG,
      optionSelectedFontWeight: 600,
    },
    Modal: {
      headerBg: COMPONENT_BG,
      contentBg: COMPONENT_BG,
    },
    Pagination: {
      itemActiveBg: 'transparent',
    },
  },
};
